module.exports = __webpack_public_path__ + "static/media/1.74978e30.png";